import './styles/about.scss';

import Layout from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Layout/Layout';
import React from 'react';
import SEO from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Seo';
import { TitleBanner } from '../components/Primitives';
import { graphql } from 'gatsby';
import useMobileDetect from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Hooks/useMobileDetect';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';

export const query = graphql`
    query {
        about: allProductsJson(filter: { code: { eq: "drolet_a-propos" } }) {
            nodes {
                code
                title {
                    en_CA
                    en_US
                    fr_CA
                }
                fields {
                    banniere_desktop {
                        childImageSharp {
                            gatsbyImageData(layout: CONSTRAINED)
                        }
                    }
                    banniere_mobile {
                        childImageSharp {
                            gatsbyImageData(layout: CONSTRAINED)
                        }
                    }
                }
                attributes {
                    content {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                        valuesMarkdownRemark {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    meta_title {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    meta_description {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
            }
        }
    }
`;

const About = ({ data }) => {
    const { currentLocale } = usePageLocalization();
    const about = data.about.nodes[0];
    const aboutContent: string =
        about?.attributes?.content?.valuesMarkdownRemark?.[0]?.[
            currentLocale
        ] ?? '';
    const metadataAttributes = data?.about?.nodes[0]?.attributes;
    const metadata = {
        title: metadataAttributes?.meta_title?.values[0][currentLocale],
        description:
            metadataAttributes?.meta_description?.values[0][currentLocale],
    };
    const pageTitle = data?.about?.nodes?.[0]?.title?.[currentLocale];
    const responsiveImages = data?.about?.nodes?.[0]?.fields;
    const desktopImage =
        responsiveImages?.banniere_desktop[0]?.childImageSharp
            ?.gatsbyImageData;
    const mobileImage =
        responsiveImages?.banniere_mobile[0]?.childImageSharp
            ?.gatsbyImageData;
    const isMobile = useMobileDetect().isMobile();

    return (
        <Layout>
            <SEO title={metadata?.title} description={metadata?.description} />
            <TitleBanner
                className='accessory-listing-titlebanner'
                imageData={isMobile ? mobileImage : desktopImage}
                title={pageTitle}
            />
            <div className='about container'>
                <div className='row-about'>
                    <div
                        id='primary'
                        dangerouslySetInnerHTML={{
                            __html: aboutContent,
                        }}
                    />
                </div>
            </div>
        </Layout>
    );
};

export default About;
